import {Component, ElementRef, NgZone, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {Content, NavController, NavParams, Platform, Slides, ViewController} from 'ionic-angular';
import {HttpService} from '../../../providers/http-service';

import {ENUM, TAcessoFind, TAction, TPaybookTipo, TPaybookModo, TPrecifyMenu, TProdutoView, TProfileSexe, TConviteTipo, TDevicerScan} from "../../../app/enum";
import {TGoogleAnalytic, Util} from "../../../app/util";
import {DomSanitizer} from "@angular/platform-browser";
import {WriterDirective} from "../../../directives/writer";
import {CONFIG} from "../../../app/config";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {DataService} from "../../../providers/data-service";
import {LogadoService} from "../../../providers/logado-service";
import {CarbookService} from "../../../providers/carbook-service";
import {MessageService} from "../../../providers/message-service";
import {ProfileService} from "../../../providers/profile-service";
import {EntrakiService} from "../../../providers/entraki-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {HotspotRepository} from "../../../repositories/hotspot-repository";

import {ModalActionPage} from "../modal-action/modal-action";
import {PublicoMenuPage} from "../publico-menu/publico-menu";
import {VoucherInfoPage} from "../voucher-info/voucher-info";
import {PaybookCartPage} from "../paybook-cart/paybook-cart";
import {PaybookMenuPage} from "../paybook-menu/paybook-menu";
import {ProdutoMenuPage} from "../produto-menu/produto-menu";
import {RetirarMenuPage} from "../retirar-menu/retirar-menu";
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {ShowbookPage} from "../../show/showbook/showbook";
import {EntrakiOpenPage} from "../entraki-open/entraki-open";
import {WebstorMenuPage} from "../webstor-menu/webstor-menu";
import {WebstorService} from "../../../providers/webstor-service";
declare var cordova: any;
@Component({
    selector: 'page-checkin-menu',
    templateUrl: 'checkin-menu.html',
    providers: [HotspotService, HotspotRepository, ProfileService, WebstorService, EntrakiService]
})
export class CheckinMenuPage {
    
    @ViewChild(Content) content: Content;

    TPaybookModo: any = TPaybookModo;

    ENUM: any = ENUM;
    config: any;
    logado: any;

    etapa: number;
    datapage: any[];

    codenear: TPaybookModo;
    warwriter: any;
    wartalked: boolean;

    qrcreated: any;

    hotloads: any[];

    _loading: boolean;

    carbook: any;
    akkjson = (window as any).handappMainInstance.appjson;

    hardwareNfc = (window as any).handappMainInstance.escutarBool;

    @ViewChild(Slides) slider: Slides;
    @ViewChildren(WriterDirective) writers: QueryList<WriterDirective>;

    @ViewChild('inputCamera') input: ElementRef;


    constructor(public navParams: NavParams, public viewCtrl: ViewController, public util: Util,
                public navCtrl: NavController, public messageService: MessageService, private ngZone: NgZone,
                public platform: Platform, public sanitizer: DomSanitizer,
                public webstorService: WebstorService,
                public logadoService: LogadoService, public dataService: DataService,
                public profileService: ProfileService,
                public hotspotService: HotspotService, public hotspotRepository: HotspotRepository,
                public entrakiService: EntrakiService,
                public carbookService: CarbookService,
                public barcodeScanner: BarcodeScanner,
                public http: HttpService,
                ) {

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Checkin', '/checkin-menu');

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = 0;
        this.datapage = [];

        this.codenear = (this.hardwareNfc ? TPaybookModo.pmNear : TPaybookModo.pmCode);
        this.warwriter = null;
        this.wartalked = false;

        this.checkinLoad(null);

        this.escutarNear();

        this.profileQrcd();
        this.checkinCall();

    }

    ionViewWillEnter() {

        setTimeout(() => {

            if (this.warwriter) this.warwriter.startLoader();

        }, 700);

    }

    ionViewDidEnter() {

        this.checkinTela();

    }


    statusbar() {

        //let color = (this.logado.Webstor ? 'CorDark' : this.akkjson.checkin.Branded.BrandedCora);
        //let style = this.util.stylesBarColor(color);
        //this.util.statusBarColor(style);

        let style = this.util.stylesBarColor('CorDark');
        this.util.statusBarColor(style);

    }

    controlK() {

        (window as any).handappMainInstance.setDevelop('Ctrl+K', null);
        
    }

    supportWork() {
    
    }

    settingZito(event) {

        if (!this.logado.Profile.ProfileTeam) return;

        if (this.akkjson.checkin) {
            let buttons: Array<any> = [];
            buttons.push({text: 'Checkout', handler: () => this.entrakiExit()});
            buttons.push({text: 'Pedeaki',  handler: () => this.carbook._DELETE_TESTE = !this.carbook._DELETE_TESTE});
            this.util.sheetOpen(buttons, 'ALTERAR');
            return;
        }

        let buttons: Array<any> = [];
        buttons.push({text: 'Chamada', handler: () => this.chamadaFile()});
        buttons.push({text: 'Setting', handler: () => this.settingOpen()});
        buttons.push({text: 'Entraki', handler: () => this.checkinList('entraki')});
        buttons.push({text: 'Checkin', handler: () => this.checkinList('checkin')});
        this.util.sheetOpen(buttons, 'OPÇÃO');

    }

    chamadaFile() {

        let options = {acceptTypes: 'text/csv', sizebyte: 0, selectLimit: 0, minmax: 'FIX', width: 0, height: 0, quality: 100};
        this.util.fileSelect(options).subscribe(
            base => {

                let arquivo = {ArquivoID: 0, ArquivoNome: base[0].info.name, ArquivoSize: base[0].info.size, ArquivoBase64: base[0].base64.split(',')[1]};
                //this.messageNova.Arquivos.push(arquivo);
                console.log(arquivo, base);

                let loading = this.util.loadingDots();
                loading.present();
        
                this.hotspotService.chamada(TAction.acFile, this.logado.Profile.ProfileID, {ChamadaFile: arquivo})
                    .finally(() => loading.dismiss())
                    .subscribe(
                        data => console.log(data),
                        erro => this.util.alertResult(erro)
                    );
        

            },

            erro => this.util.alertResult(erro)
        );

    }

    settingOpen() {

        //#GAMBI - Vem do Webster tem que respirar para abrir
        this.ngZone.run(() => this.navCtrl.push(WebstorMenuPage, null, {animation: 'md-transition'}));

    }

    checkinLoad(open: null | 'entraki' | 'checkin') {

        let onPick = (data) => {

            this.hotloads = data.Hotspots;
            this.hotspotRepository.subscribeFolloweChanged(this.hotloads).subscribe();

            if (open) this.checkinList(open);

        };

        let loading = this.util.loadingDots();
        if (open) loading.present();

        this.hotspotService.hotspot(TAction.acGoin, 0, this.logado.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPick(data),
                erro => this.util.alertResult(erro)
            );

    }

    checkinList(open: 'entraki' | 'checkin') {

        if (!this.hotloads) {
            this.checkinLoad(open);
            return;
        }

        let onGoin = (hotspot) => {
            let _paybase = true;
            if (open == 'entraki') this.processScan(TPaybookModo.pmNear, JSON.stringify(hotspot), true);
            if (open == 'checkin') (window as any).handappMainInstance.checkinCall(hotspot.MaxbookID, _paybase, 1050);
        };

        let buttons: Array<any> = [];
        this.hotloads.forEach(hotspot => buttons.push({text: hotspot.Branded.BrandedShow, value: hotspot}));

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = 0;
        this.util.pickerOpen(columns, onGoin);

    }

    sliderIcon(tipo: 'ICO' | 'COR', position: 'L' | 'R' = null, index?): string {

        let paybook = this.akkjson.checkin;

        if (tipo == 'COR') {
            if (!paybook) return this.config.spotus.BrandedCora;
            if (paybook)  return this.config.negative(paybook.Branded.BrandedCora);
        }

        if (tipo == 'ICO' && position == 'L' && paybook) {
            if (index == 1) return 'b-icon-qrcode';
            if (index == 2) return 'b-icon-credit-card';
            if (index == 3) return 'b-icon-beer-1';
        }

        if (tipo == 'ICO' && position == 'R' && paybook && index < this.datapage.length - 1) {
            if (index == 0) return 'b-icon-credit-card';
            if (index == 1) return 'b-icon-location-7';  //'b-icon-beer-1'
        }

        return '';

    }

    sliderMove(event) {

        setTimeout(() => {

            let index = this.slider.getActiveIndex();
            if (this.datapage[index] && this.datapage[index].warwriter) this.datapage[index].warwriter.startLoader();

            if (!this.akkjson.checkin) this.dataService.set('tebselected', index);

        }, 700);

    }

    warning() {

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'liacheckin')};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

        this.codenear = (this.codenear == TPaybookModo.pmNear ? TPaybookModo.pmCode : TPaybookModo.pmNear);

    }

    opencode() {

        this.wartalked = true;
        this.etapa++;

    }





    //AS 3 ROTINAS...
    //chamar a pictureOpen() ou pictureLoad()

    pictureFile(data64, concatTag: boolean) {

        //if (!data64) return;
        //if (concatTag) data64 = 'data:image/jpeg;base64,' + data64;

        //this.image = new Image;
        //this.image.src = data64;
        //this.image.onload = () => {};

    }

    pictureOpen() {

        this.util.pictureOpen(this.input).subscribe(
            data => this.pictureFile(data, true),
            erro => this.util.alertSimply(erro)
        );

    }

    pictureLoad(eventOrBase64) {

        this.util.pictureLoad(eventOrBase64, false).subscribe(
            data => this.pictureFile(data, false),
            erro => this.util.alertSimply(erro)
        );

    }







    xxxx(filename) {


    }




    profileQrcd() {

        if (!this.util.nativeApp()) return;

      //let json = {ProfileID: this.logado.Profile.ProfileHash};
        let json = {ProfileID: this.logado.Profile.ProfileID};
        let text = JSON.stringify(json);
        let save = this.util.criptRede(text, true);

        let options = {
            width: 256,
            height: 256,
            colorDark: CONFIG.colors.CorLime,
            colorLight: "#ffffff",
        };

        cordova.plugins.qrcodejs.encode('TEXT_TYPE', save, (base64EncodedQRImage) => {
            //alert('QRCodeJS response is ' + base64EncodedQRImage);
            this.qrcreated = base64EncodedQRImage;
            //TODO: use your base64EncodedQRImage

            //QRCODE -> Paint
            // setTimeout(() => {
            //     let top = CONFIG.colors.CorWhat;//this.util.anyParams(CONFIG.colors.CorWhat, CONFIG.colors[this.vouchers[this.selected].QRTOP]);
            //     let end = CONFIG.colors.CorBlue;//this.util.anyParams(CONFIG.colors.CorBlue, CONFIG.colors[this.vouchers[this.selected].QREND]);
            //     this.util.qrcolor(data, top, end)
            //         .subscribe(base64 => {
            //             this.qrcreated = base64;
            //         });
            // });


          }, (err) => {
            alert('QRCodeJS error is ' + JSON.stringify(err));
          }, options);
    }

    profileQrcdX() {

        this.barcodeScanner.encode(this.barcodeScanner.Encode.TEXT_TYPE, this.logado.Profile.ProfileHash)
            .then(data => {

                //QRCODE -> Cria
                //this.qrcreated = 'data:image/jpeg;base64,' + data;
                this.qrcreated = data.file;
                let array = this.qrcreated.split('/');
                let xFile = array[array.length-1];
                array.splice(array.length-1);

                let xPath = array.join('/');
                alert(xFile + '->' + xPath);
                
                // Convert file to base64 string
                // const fileToBase64 = (filename, filepath) => {
                //     return new Promise(resolve => {
                //     var file = new File([filename], filepath);
                //     var reader = new FileReader();
                //     // Read file content on file loaded event
                //     reader.onload = () => {
                //         alert(JSON.stringify(reader.result));
                //         resolve(reader.result);
                //     };

                //     alert(JSON.stringify(file));
                //     // Convert data to base64 
                //     reader.readAsDataURL(file);
                //     });
                // };

                // fileToBase64(xFile, xPath).then(result => {
                //     alert(JSON.stringify(result));
                // });

alert(this.qrcreated);
                this.http.get(this.qrcreated, { responseType: 'blob' })
                .subscribe(res => {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    var base64data = reader.result;
                        alert(base64data);
                  }
          
                  reader.readAsDataURL(res);
                  alert('X->'+JSON.stringify(res));
                });
                
                
                //alert('a');
                //alert(this.qrcreated);
                //alert(JSON.stringify(data));


                //QRCODE -> Paint
                // setTimeout(() => {
                //     let top = CONFIG.colors.CorWhat;//this.util.anyParams(CONFIG.colors.CorWhat, CONFIG.colors[this.vouchers[this.selected].QRTOP]);
                //     let end = CONFIG.colors.CorBlue;//this.util.anyParams(CONFIG.colors.CorBlue, CONFIG.colors[this.vouchers[this.selected].QREND]);
                //     this.util.qrcolor(data, top, end)
                //         .subscribe(base64 => {
                //             this.qrcreated = base64;
                //         });
                // });

            }).catch(erro => {

            //let text = (!this.platform.is('cordova') ? 'Camera apenas no ambiente "Cordova"' : 'Você precisa fornecer acesso a sua camera para continuar.' + '<br><br>' + erro);
            //this.util.alertSimply(erro);

        });

    }

    entrakiExit() {

        let loading = this.util.loadingDots();
        loading.present();

        let hotspotID = this.akkjson.checkin.HotspotID;
        let params = '&ComandaID=' + this.akkjson.checkin.ComandaID;

        this.util.monitorDesk(false, 'DESK-Started', hotspotID, params, TAction.acExit)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    
                    if (data.Comandas[0] && !data.Comandas[0].Outbook.OutbookBool) {
                        this.util.alertSimply('Efetue o pagamento no caixa!', data.Comandas[0].Outbook.OutbookText, 'OK, entendi', true);
                    }

                    if (data.Comandas[0] && data.Comandas[0].Outbook.OutbookBool) {
                        let paybook = this.akkjson.checkin;
                        let paycopy = this.util.deepCopy(paybook);
                        paycopy.Followe = {}; //#GAMBI - Para pedir avaliacao, certo deveria ter vindo da Bridge com os dados da ultima avaliacao.
    
                        let object = {etapa: 4, checkinSelf: true, hotspot: null, spotdayID: 0, paybook: paycopy, paybookTipo: paycopy.PaybookTipo, paybookModo: paycopy.PaybookModo};
                        this.util.modalopen(EntrakiOpenPage, 'quad', true, object).subscribe();
    
                        (window as any).handappMainInstance.checkinCall(0, false, hotspotID);
                    }

                },
                erro => this.util.alertResult(erro)
            );


        //#BRIDGE
        // let onExit = () => {
        //     let paybook = this.akkjson.checkin;
        //     let paycopy = this.util.deepCopy(paybook);

        //     if (!paybook.PaybookBora) {
        //         paybook.PaybookBora = this.util.dateToStr(null, true);
        //         paycopy.PaybookBora = this.util.dateToStr(null, true);
        //     }

        //     let object = {etapa: 4, hotspot: null, spotdayID: 0, paybook: paycopy, paybookTipo: paycopy.PaybookTipo, paybookModo: paycopy.PaybookModo};
        //     this.util.modalopen(EntrakiOpenPage, 'quad', true, object).subscribe();

        //     (window as any).handappMainInstance.checkinCall();
        // };

        // let loading = this.util.loadingDots();
        // loading.present();

        // this.hotspotService.paybook(TAction.acExit, this.akkjson.checkin.PaybookID)
        //     .finally(() => loading.dismiss())
        //     .subscribe(
        //         data => onExit(),
        //         erro => this.util.alertResult(erro)
        //     );

    }

    entrakiOpen(paymodo: TPaybookModo, hotspotID) {

        let onDone = (data) => {

            let object = {etapa: 0, monitorBool: false, hotspot: data, spotdayID: 0, profileDesk: this.logado.Profile, paybookTipo: TPaybookTipo.pbCard, paybookModo: paymodo, checkinSelf: true, conviteTipo: TConviteTipo.ctConvitePorta};
            this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
                .subscribe(done => {

                    //Checkin
                    let EXCLUIR_maxbookID = 0;
                    let hotspot = (this.hotloads || []).find(HS => HS.HotspotID == hotspotID);
                    if (hotspot) {
                        hotspot.Profile = this.util.deepCopy(this.logado.Profile);
                        EXCLUIR_maxbookID = hotspot.MaxbookID;
                    }

                    //Para acelerar....
                    (window as any).handappMainInstance.checkinCall(EXCLUIR_maxbookID, (EXCLUIR_maxbookID > 0), hotspotID);

                });

        };

        this._loading = true;
        this.entrakiService.entraki(TAction.acInit, hotspotID, 0, this.logado.Profile.ProfileID, '', TConviteTipo.ctConvitePorta)
            .finally(() => this._loading = false)
            .subscribe(
                data => onDone(data.Hotspot),
                erro => this.util.alertResult(erro)
            );

    }

    processScan(paymodo: TPaybookModo, txtjson, runfast?) {

        //console.log(json);
        let json = this.util.jsParse(txtjson);
        if (!json) {
            this.util.alertSimply(txtjson, 'JSON ERROR');
            return;
        }

        //hotspotScan - Enter
        if (json.HotspotID) {

            //Checkin
            if (!this.akkjson.checkin) {
                let onZone = () => this.ngZone.run(() => this.entrakiOpen(paymodo, json.HotspotID));
                if ( runfast) onZone();
                if (!runfast) setTimeout(() => onZone(), 3000);
            }

            //Checkot
            if (this.akkjson.checkin) {
                let onZona = () => this.ngZone.run(() => this.entrakiExit());
                if ( runfast) onZona();
                if (!runfast) setTimeout(() => onZona(), 3000);
                return;
            }

        }


        //ambientScan
        if (json.AmbientID) {
            //Check consumo para entrar no ambiente camarote
        }


        //stationScan
        if (json.StationID) {
            //Check voucher para entrar na station FOX-123
        }

    }

    escutaScan() {

        (window as any).handappMainInstance.escutarScan();

    }

    escutarNear() {

        this.messageService.get(TDevicerScan[TDevicerScan.dsEntraki]).subscribe(
            data => this.processScan(TPaybookModo.pmNear, data, this.platform.is('android'))
        );

    }

    barcodeScan() {

        let loading = this.util.loadingDots();
        loading.present();

        let option = {showTorchButton: true};
        this.barcodeScanner.scan(option).then(
            data => {
                loading.dismiss();
                if (data.cancelled) return;
                let txtjson = this.util.criptRede(data.text, false);
                this.processScan(TPaybookModo.pmCode, txtjson, true);
                }).catch(
            erro => {

                loading.dismiss();
                let text = (!this.platform.is('cordova') ? 'Instale o app na Loja' : 'Você precisa fornecer acesso a sua camera para continuar.' + '<br><br>' + erro);
                this.util.alertSimply(text);

            });

    }

    voucherMenu() {

        let objectData = {etapa: 0, voucherID: 0, profileID: this.logado.Profile.ProfileID, hotspotID: 0};
        this.util.modalopen(VoucherInfoPage, 'alto', false, objectData).subscribe();

    }

    publicoLove() {

        let paybook = this.akkjson.checkin;
        let object = {etapa: 1, rootile: this.logado, hotspotID: paybook.HotspotID, paybookBase: paybook.PaybookBase, paybookFull: true, branded: paybook.Branded};
        this.navCtrl.push(PublicoMenuPage, object, {animation: 'md-transition'});

    }

    retirarMenu() {

        //em andamento -> Myhobby | Myfood | Mycup
        let object = {etapa: 0};
        this.navCtrl.push(RetirarMenuPage, object);

    }

    produtoMenu() {

        //Mycup - Pedido
        let rootspot = {Hotspots: [this.akkjson.checkin]};
        let object = {etapa: 1, homeb: false, rootspot: rootspot, produtoFull: false, produtoView: TProdutoView.pdPrecify, precifyMenu: TPrecifyMenu.pcNormal};
        this.navCtrl.push(ProdutoMenuPage, object);

    }

    horarioMenu() {

        if (!this.akkjson.stations) return;

        //Sport - Manifesto
        //let datadate = this.util.strToData('22/03/2019');//new Date();
        let datafind = '22/03/2019';//this.datepipe.transform(datadate, 'dd/MM/yyyy');
        console.log(datafind);

        let alignL = {type: 'logo', text: '', show: 'StationFoto', info: '',            color: ''};
        let alignC = {type: 'text', text: '', show: 'StationNome', info: 'StationInfo', color: ''};
        let alignR = {type: 'rank', text: '', show: 'BrandedShow', info: '',            color: ''};

        let onShow = (show, that, limitPage, reload) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.horario(TAction.acLoad, 0) //, limitPage, datafind)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {
                        objectData.modalshow.titulo = 'Sunset: 18h02 - CAT D';
                        that.parseArray(data.Horarios);
                    },
                    erro => {
                        this.util.alertResult(erro, () => that.dismiss())
                    }
                )

        };

        let onOkuy = (okey, that, line, click, event) => {

            //Skydive Acessar
            let object = {skydeco: line, readonly: true};
            this.navCtrl.push(ShowbookPage, object);

        };

        let modalshow = this.config.listingForm('Decolagem', onShow, onOkuy, alignL, alignC, alignR, 'CorRoxa');
        let objectData = {profile: this.logado.Profile, modalshow: modalshow, tabmenu: false};
        objectData.modalshow.header = 'Showdive';
        objectData.modalshow.titulo = 'Aberto para...';
        objectData.modalshow.resumo = datafind;
        objectData.modalshow.imagem = 'assets/img/icon/ic-tradetd-takeoff.png';

        this.navCtrl.push(ListingMenuPage, objectData);

    }

    paybookOpen(paybook) {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Compraki',    handler: () => this.produtoMenu()});
        buttons.push({text: 'Visualizaki', handler: () => this.paybookMenu(paybook)});
        buttons.push({text: 'Manifestaki', handler: () => this.horarioMenu()});
        buttons.push({text: 'Remover',     handler: () => this.paybookTira(paybook), role: 'destructive'});
        this.util.sheetOpen(buttons, 'PAYBOOK');

    }

    paybookMenu(paybook) {

        let object = {etapa: 0, olhaapp: false, fronter: false, profile: paybook.Profile, branded: paybook.Branded, workday: true, userset: null, paybookID: paybook.PaybookID, paybook: paybook};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();

    }

    paybookTira(paybook) {

        this.carbookService.paybookTira(paybook);

    }

    paybookPush(paybook) {

        if (!paybook) return;

        let index = this.carbook.Paybooks.findIndex(PB => PB.PaybookID == paybook.PaybookID);

        if (index >= 0) this.util.clearObj(this.carbook.Paybooks[index], [], paybook);
        if (index < 0)  this.carbookService.paybookPush(paybook);

    }

    paybookFind() {

        if (!this.util.validaCNPF(this.carbook._documento)) return;

        let loading = this.util.loadingDots();
        loading.present();

        //Bridging...
        // let paybase = (this.akkjson.checkin._paybase ? this.akkjson.checkin.PaybookBase : 'CURRENT_TIMESTAMP');
        // let params = '&ProfileRnid=' + this.carbook._documento + '&HotspotID=' + this.carbook.Hotspot.HotspotID + '&PaybookBase=' + paybase;
        // this.carbook._documento = '';
        // this.profileService.profile(TAction.acGoin, 0, null, params)
        //     .finally(() => loading.dismiss())
        //     .subscribe(
        //         data => this.paybookPush((data.Paybooks || [])[0]),
        //         erro => this.util.alertResult(erro)
        //     );

        let params = '&ComandaText=' + this.carbook._documento +
                     '&ComandaMode=' + TAcessoFind.afFindRnid;
        setTimeout(() => this.carbook._documento = '', 500);
        this.util.monitorDesk(false, 'DESK-Comanda', this.carbook.Hotspot.HotspotID, params, TAction.acFind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.paybookPush((data.Comandas || [])[0]),
                erro => this.util.alertResult(erro));


    }

    paybookCart() {

        // if (this.carbook.Paybooks.length > 1 && this.paybookCash() <= 0) {
        //     this.util.toastSimply('Nenhum valor a pagar');
        //     return;
        // }
        
        let object = {etapa: 0};
        this.navCtrl.push(PaybookCartPage, object);

    }

    checkinCall() {

        this.messageService.get('checkin.call')
            .subscribe(data => {

                this.akkjson = (window as any).handappMainInstance.appjson;
                this.checkinTela();

            });

    }

    checkinTela() {

        //Vai trocar status sempre vai para etapa = 0
        if (this.akkjson.changed) {
            this.etapa = 0;
            this.carbook = this.carbookService.getCarrinho();
        }

        //Color [connect]
        this.statusbar();


        //ENTRAKI-NONE
        if (this.akkjson.changed || !this.datapage.length) {
            let warning = 'Olá, seu <b>checkin</b> agora é <b>digital</b>!<br>' + 'Aproxime ou use o <b>QRCode</b>.';
            let werning = 'Para você entrar em um lugar que eu controlo, use o <b>QR Code</b>.';

            if (this.akkjson.checkin) {
                warning = 'Bem vindo ' + ENUM.profileSexe(this.akkjson.checkin.Branded.BrandedSexo, TProfileSexe.psAoAa).toLowerCase() + ' <b>' + this.akkjson.checkin.Branded.BrandedNome + '</b>.' + '<br>' + '<b>Click e aproxime</b> o celular.';
            }

            let page00 = {title: 'Entraki', texto: 'Para entrar e sair!', warwriter: null, warning: warning, werning: werning};
            this.datapage = [page00];
        }


        //ENTRAKI-SPOT
        if (this.akkjson.changed && this.akkjson.checkin) {
            let page01 = {title: 'Payout', texto: 'Pague no celular!', warwriter: null, warning: null, werning: null};
            let page02 = {title: 'Finder', texto: 'Pessoas no rolê!', warwriter: null, warning: null, werning: null};
            this.datapage.push(page01);
            this.datapage.push(page02);
        }


        //Warning definido o que vai escrever!
        let slidetab = (this.akkjson.checkin ? 1 : 0);
        if (this.akkjson.changed) setTimeout(() => this.slider.slideTo(slidetab, 0), 200);
        if (this.akkjson.changed) this.sliderMove(null);

        this.slider.lockSwipes((this.akkjson.checkin ? false : true));
        this.akkjson.changed = false;
        this.ngZone.run(() => {});

    }

}




// WEBPACK FOOTER //
// ./src/pages/sync/checkin-menu/checkin-menu.ts